import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { cssTextAtm } from "../TextAtm/TextAtm.styled";
import { labelSizes, labelTypography, labelVariantsBackgrounds } from "./LabelAtm.config";
export var getLabelTextColor = function getLabelTextColor(variant) {
  switch (variant) {
    case "successLight":
      return "success";
    case "successLightWithBorder":
      return "success";
    case "successLightWithDarkText":
      return undefined;
    case "lightBlue":
      return "blue";
    case "primaryOutlined":
      return "primary";
    default:
      return undefined;
  }
};
export var getLabelBorderColor = function getLabelBorderColor(variant) {
  switch (variant) {
    case "primaryOutlined":
      return "primary";
    case "successLightWithBorder":
      return "success";
    default:
      return undefined;
  }
};
export var labelSizeStyles = function labelSizeStyles(size) {
  var sizeType = labelSizes[size];
  if (typeof sizeType.paddingSpace === "number") {
    return css(["padding:", ";"], space(sizeType.paddingSpace));
  }
  return css(["padding:", " ", ";"], space(sizeType.paddingSpace.y), space(sizeType.paddingSpace.x));
};
export var StyledLabelAtm = styled.p.withConfig({
  componentId: "sc-1kk0w83-0"
})(function (_ref) {
  var $size = _ref.$size,
    $variant = _ref.$variant,
    $emphasis = _ref.$emphasis,
    $onColor = _ref.$onColor,
    $hasIcon = _ref.$hasIcon,
    $wrapLabel = _ref.$wrapLabel,
    $borderRadius = _ref.$borderRadius,
    theme = _ref.theme;
  var variantBackgroundColor = labelVariantsBackgrounds[$variant];
  var color = getLabelTextColor($variant);
  var borderColor = getLabelBorderColor($variant);
  return css(["", ";", ";display:inline-block;border-radius:", ";", " ", " ", "  ", ""], cssTextAtm({
    typography: labelTypography,
    onColor: variantBackgroundColor !== null && variantBackgroundColor !== void 0 ? variantBackgroundColor : $onColor,
    color: color,
    emphasis: ($variant === "notifyLight" || $variant === "outlined") && !$emphasis ? "medium" : $emphasis
  }), labelSizeStyles($size), getBorderRadius(theme, $borderRadius), !$wrapLabel && css(["white-space:nowrap;"]), variantBackgroundColor ? css(["background-color:", ";"], getColor(theme, variantBackgroundColor)) : css(["box-shadow:inset 0 0 0 ", " ", ";"], unit(1), borderColor ? getColor(theme, borderColor) : getBorderColor(theme, $onColor, "high")), variantBackgroundColor && borderColor ? css(["box-shadow:inset 0 0 0 ", " ", ";"], unit(1), getColor(theme, borderColor)) : null, $hasIcon && css(["display:flex;align-items:center;width:max-content;"]));
});
export var IconWrapper = styled.span.withConfig({
  componentId: "sc-1kk0w83-1"
})(["margin-right:", ";"], unit(4));